if (!customElements.get('sticky-product-nav')) {
  customElements.define('sticky-product-nav', class StickyProductNav extends HTMLElement {

    static SELECTORS = {
      SWIPER_VARIANT_DESKTOP: '.product-nav__variant-picker--desktop .variant-picker-slider',
      SWIPER_VARIANT_MOBILE: '.product-nav__variant-picker--mobile .variant-picker-slider',
      BTN_PREV_DESKTOP: '.product-nav__variant-picker--desktop .swiper-button-prev',
      BTN_NEXT_DESKTOP: '.product-nav__variant-picker--desktop .swiper-button-next'
    }

    constructor() {
      super()
      this.observer = null
      this.swiperDesktop = null
      this.swiperMobile = null
    }

    connectedCallback() {
      this._observeScroll()
      this._initSwiper()
    }

    _initSwiper() {
      const swiperVariantDesktop = document.querySelector(StickyProductNav.SELECTORS.SWIPER_VARIANT_DESKTOP)
      const btnPrevDesktop = document.querySelector(StickyProductNav.SELECTORS.BTN_PREV_DESKTOP)
      const btnNextDesktop = document.querySelector(StickyProductNav.SELECTORS.BTN_NEXT_DESKTOP)
      const swiperVariantMobile = document.querySelector(StickyProductNav.SELECTORS.SWIPER_VARIANT_MOBILE)

      if (swiperVariantDesktop) {
        Object.assign(swiperVariantDesktop, {
          slidesPerView: 4,
          spaceBetween: 8,
          loop: false,
          navigation: {
            nextEl: btnNextDesktop,
            prevEl: btnPrevDesktop,
          },
        })

        swiperVariantDesktop.initialize()
        this.swiperDesktop = swiperVariantDesktop.swiper
      }

      if (swiperVariantMobile) {
        Object.assign(swiperVariantMobile, {
          slidesPerView: 3.5,
          spaceBetween: 8,
          loop: false,
          navigation: false,
        })

        swiperVariantMobile.initialize()
        this.swiperMobile = swiperVariantMobile.swiper
      }
    }

    _observeScroll() {
      const productSection = document.querySelector('.product')
      const productSectionList = document.querySelectorAll('.product-variants')

      if (productSectionList.length > 0) return

      if (productSection) {
        this.observer = new IntersectionObserver((entries) => {
          entries.forEach(entry => {
            if (entry.isIntersecting) {
              this.classList.remove('is-sticky')
            } else {
              this.classList.add('is-sticky')
            }
          })
        })

        this.observer.observe(productSection)
      }
    }

    disconnectedCallback() {
      if (this.observer) this.observer.disconnect()
      if (this.swiperDesktop) this.swiperDesktop.destroy(true, true)
      if (this.swiperMobile) this.swiperMobile.destroy(true, true)
    }
  })
}